import { render, staticRenderFns } from "./MessageQuote.vue?vue&type=template&id=361fd53a&"
import script from "./MessageQuote.vue?vue&type=script&lang=js&"
export * from "./MessageQuote.vue?vue&type=script&lang=js&"
import style0 from "./MessageQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports